import { AuthService } from '../user/auth.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RegistryFirebaseService } from './registry-firebase.service';
import { Contribution } from '../track/contribution';
import { Settings } from '../settings/settings';

@Injectable()
export class SettingsResolve implements Resolve<any> {

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Settings> {
    const pageUserMode = route.data.pageUserMode;
    const registryName = route.paramMap.get('registry') ? route.paramMap.get('registry') : route.parent.paramMap.get('registry');

    return this._registryFirebaseService.regforUser().take(1).switchMap(reg => {

if (reg ) {

        return this._registryFirebaseService.getSettingsForUser(reg.userId, reg.id).take(1);
} else {
  return Observable.of(null);
}

    });

  }
}



// WEBPACK FOOTER //
// ./src/app/registry/settings.resolve.ts